<template>
  <div class="container-wrap">
    <div class="title">
      <h1 class="title_text" >{{title}}</h1>
    </div>
    <div class="first">
      <p class="text">Your next step - before we can issue coins - is to complete the KYC process. We've made it really quick and streamlined for you...</p>
      <h2 class="h2" style="padding:25px 0">IMPORTANT NOTE</h2>
      <p class="text" style="margin-bottom:10px">- This process is JUST for Individuals. IE: For Your Personal TPR Wallet ONLY.</p>
      <p class="text" style="margin-bottom:20px">* If you have a SMSF, Trust or Business that is holding coins we will reach out to you and let you know once we are ready to transfer those coins to you.</p>
      <p class="text" style="margin-bottom:20px">** It won't be long - just one step at a time is all.</p>
    </div>
    <div class="first">
      <p class="text">The Link To Complete Your KYC Process is Below...</p>
      <h2 class="h2" style="padding:25px 0">WHAT YOU WILL FIRST SEE:</h2>
      <p class="text" style="margin-bottom:10px"> An option to choose country - Choose, Australia (Unless you are in another country)</p>
      <p class="text" style="margin-bottom:20px">An Option to Choose Identity type: Choose, Individual</p>
    </div>
    <div class="details">
      <h2 class="h2" style="margin-bottom:5px">NAME SECTION:</h2>
      <p class="text" style="margin-bottom:20px">* ALL NAMES HAVE TO BE LEGAL NAMES (IE: Christopher not Chris)</p>
      <p class="text" style="margin-bottom:10px"><strong>First Name:</strong> Your legal first name</p>
      <p class="text" style="margin-bottom:10px"><strong>Middle Name:</strong>  ENTER MIDDLE NAME IF YOU LEGALLY HAVE ONE</p>
      <p class="text" style="margin-bottom:20px"><strong>Last Name:</strong>  Your legal last name</p>
      <p class="text" style="margin-bottom:10px"><strong>Gender:</strong> Your Gender</p>
      <p class="text" style="margin-bottom:10px"><strong>Email:</strong> Your Email</p>
      <p class="text" style="margin-bottom:10px"><strong>DOB:</strong >Your LEGAL DOB</p>
      <p class="text" style="margin-bottom:10px"><strong> ADDRESS:</strong>Your CURRENT Address</p>
      <p class="text" style="margin-bottom:10px"><strong> ID Document</strong>- Select "NONE"</p>
      <p class="text" style="margin-bottom:10px"><strong>Second ID Document:</strong>- Select "NONE"</p>
      <p class="text" style="margin-bottom:10px">***We do not require at this point in time for you to upload any ID.</p>
      <p class="text" style="margin-bottom:10px">If you choose to and it is easy for you, to do so, then please do but it is not required.</p>
    </div>
    <div class="link" >
      <p class="text" style="margin-bottom:10px; text-align:left">Read & Agree to the T's & C's</p>
      <p class="text" style="margin-bottom:10px; text-align:left">Hit Submit!</p>
      <p class="text" style="margin-bottom:10px; text-align:center">Here's the link to complete your KYC process:</p>
      <a href="https://portal.bronid.com/idform/thepeoplesreserve" target="_blank">https://portal.bronid.com/idform/thepeoplesreserve</a>
    </div>
    <div class="button">
      <button class="btn" @click="goToLink">{{textButton}}</button>
    </div>
  </div>
</template>

<script>
  export default {
    computed: {
      title() {
        const urlParams = new URLSearchParams(window.location.search);
        const reg = urlParams.get("fromRegistration")
        if (reg) {
          return "Thank you for registering on the TPR Coin Distribution platform."
        } else {
          return "Identity Verification - KYC"
        }
      },
      textButton() {
        const urlParams = new URLSearchParams(window.location.search);
        const reg = urlParams.get("fromRegistration")
        if (reg) {
          return "login"
        } else {
          return "Return to my status page"
        }
      }
    },
    methods: {
      goToLink() {
        const urlParams = new URLSearchParams(window.location.search);
        const reg = urlParams.get("fromRegistration")
        if (reg) {
          this.$router.push("/login")
        } else {
          this.$router.push("/profile")
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
.container-wrap {
  width: 100%;
  max-width: 970px;
  background-color: #fff;
  padding: 0 27px;
  margin-bottom: 20px;
  .title {
    padding: 40px 0;
    border-bottom: 1px solid #CBCDFF;
    margin-bottom: 20px;
    &_text {
      font-style: normal;
      font-weight: normal;
      font-size: 24px;
      line-height: 28px;
      text-align: center;
      color: rgba(0, 0, 0, 0.87);
    }

  }
  .first {
    border-bottom: 1px solid #CBCDFF;
    margin-bottom: 20px;
    
  }
  .details {
    border-bottom: 1px solid #CBCDFF;
    margin-bottom: 20px;
  }
  .document {
    border-bottom: 1px solid #CBCDFF;
    margin-bottom: 20px;
  }
  .link {
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid #CBCDFF;
    margin-bottom: 20px;
    padding-bottom: 20px;
    a {
      text-align: center;
      text-decoration: none;
      color: #555555;
    }
  }
  .button {
    padding: 20px;
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    .btn {
      max-width: 400px;
      flex: 1 1 auto;
      padding: 16px;
      border: none;
      outline: none;
      cursor: pointer;
      background: #FFE709;
      border-radius: 4px;
      text-transform: uppercase;
    }
  }
}
.text {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #555555;
}
.h2 {
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: #555555;
}
</style>